import React from 'react'
import {Container} from "reactstrap"
import { MDBIcon } from "mdbreact"
import {Table,Button} from "react-bootstrap"
import "./references.css"
import Header from "./Header"
import Footer from "./Footer"

function References() {
    return (
        <div className="row">
        <div className="col-md-12">
        <div className = "references__page">
        <Header/>
        <div className = "references__content">
                <p><strong>Reference Values for Calculation</strong></p>
                <Table className = "ref__table" striped bordered hover responsive= "sm" size="sm" > 
                <thead>
                    <tr>
                        <th>
                            Type
                        </th>
                        <th>
                            Energy (kcal/100ml)
                        </th>
                        <th>
                            Protein (g/100ml)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>P22</td>
                        <td>74</td>
                        <td>2.1</td>
                    </tr>
                    <tr>
                        <td>P24</td>
                        <td>81</td>
                        <td>2.4</td>
                    </tr>
                    <tr>
                        <td>Breast Milk</td>
                        <td>75</td>
                        <td>1.3</td>
                    </tr>
                    <tr>
                        <td>HMF 1:25 Ratio</td>
                        <td>14</td>
                        <td>1.0</td>
                    </tr>
                    <tr>
                        <td>HMF 1:50 Ratio</td>
                        <td>7</td>
                        <td>0.5</td>
                    </tr>
                    <tr>
                        <td>Whey Protein</td>
                        <td>415</td>
                        <td>79.8</td>
                    </tr>
                </tbody>
            </Table>
            <div className = "references__word">
            <p><strong>References : </strong></p>
                <p>1.   Agostoni C, Buonocore G, Carnielli VP, et al. Enteral nutrient supply for preterm infants; commentary from the European Society of Paediatric Gastroenterol, Hepatology and Nutrition Committee on Nutrition. Pedeatr Gastroenterol Nutr. 2010;50(1):85-91.</p>
                <p>2.   Fenton TR, Kim JH. Systematic review and meta-analysis to revise the Fenton growth chart for preterm infants. BMC Pediatric. 2013;13:59.</p>
                <p>3.   Gidrewics DA, Fenton TR. A systemic review and meta-analysis of the nutrient content of preterm and term breast milk. </p>
                <p>4.   Joosten K, Embleton N, Yan W, et al. ESPGHAN/ESPEN/ESPR/CSPEN guidelines on pediatric parenteral nutrition: Energy. Clin Nutr. 2018;37(6 PtB):2309-14.</p>
                <p>5.   Koletzko B, Pointdexter B, Uauy R. Nutritional Care of Preterm Infants: Scientific Basic and Practical Guidelines. Germany: Karger, 2014. </p>
                <p>6.   Lapillone A, Bronsky J, Campoy C, et al. Feeding the Late and Moderately Preterm Infant: A Position Paper of the European Society of Paediatric Gastroenterology, Hepatology and Nutrition Committee on Nutrition. Pediatr Gastroenterol Nutr. 2019;69(2):259-70.</p>
                <p>7.   Patel AL, Engstrom JL, Meier PP, Kimura RE. Accuracy of methods of calculating postnatal growth velocity for extremely low birth weight infants. Pediatrics. 2005;116(6):1466-1473.  </p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
            </div>
            </div>  
            </div>
            </div>
        </div>
    )
}

export default References
